var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { ArrowDropDownIcon } from '../../atoms/Icons';
var UserList = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  div {\n    box-sizing: border-box;\n    padding-right: 5px;\n    display: inline-block;\n    width: 50%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    text-decoration: underline;\n  }\n"], ["\n  div {\n    box-sizing: border-box;\n    padding-right: 5px;\n    display: inline-block;\n    width: 50%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    text-decoration: underline;\n  }\n"])));
var ExpandUser = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  span {\n    cursor: pointer;\n    font-size: 12px;\n  }\n"], ["\n  span {\n    cursor: pointer;\n    font-size: 12px;\n  }\n"])));
var CommentsSummaryUsers = function (_a) {
    var users = _a.users;
    var t = useTranslation().t;
    var showMinUsersCount = 6;
    var _b = React.useState(), showAllUser = _b[0], setShowAllUser = _b[1];
    React.useEffect(function () { return setShowAllUser(users.length <= showMinUsersCount); }, [users]);
    var visibleUsers = React.useMemo(function () { return (showAllUser ? users : users.slice(0, showMinUsersCount)); }, [users, showAllUser]);
    if (!users)
        return null;
    return (React.createElement("div", { className: "users" },
        React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.body4; }, mb: 1 } }, t('pages.cuppingComments.commentedBy')),
        React.createElement(UserList, null, visibleUsers.map(function (user, i) {
            var name = user.roaster
                ? "".concat(user.roaster.storeName || '', " ").concat(t('fullname', user.roaster))
                : user.name;
            return React.createElement("div", { key: "user-".concat(i) }, name);
        })),
        !showAllUser && (React.createElement(ExpandUser, null,
            React.createElement("span", { onClick: function () { return setShowAllUser(true); } },
                t('pages.cuppingComments.otherRoasters', {
                    count: users.length - visibleUsers.length,
                }),
                React.createElement(ArrowDropDownIcon, { sx: { fontSize: '14px', verticalAlign: 'middle' } }))))));
};
export default CommentsSummaryUsers;
var templateObject_1, templateObject_2;
